import { MESES, addZeroToNum } from "./inputs";
import { getDaysInMonth } from "../utils";

export const parseDateForTxt = (date) => {
  date = date.split("-");
  const d = date[0];
  const m = date[1];
  const y = date[2];

  return `${y}${addZeroToNum(m)}${addZeroToNum(d)}`;
};

export const parseRutForTxt = (rut) => {
  const parts = rut ? rut.split("-") : ["", ""];
  const verificationNum = parts[1];
  let rutWithoutVerifyingNumber = parts[0];

  rutWithoutVerifyingNumber = rutWithoutVerifyingNumber.replace(/\./g, "");

  if (+rutWithoutVerifyingNumber < 100000000) {
    rutWithoutVerifyingNumber = `0${rutWithoutVerifyingNumber}`;
  }

  return `${rutWithoutVerifyingNumber}${verificationNum}`;
};

export const calcWorkedDays = (steps, fechaInicio, fechaTermino) => {
  const { step1 } = steps;

  let dayInit, dayTerm;

  if (!fechaInicio) {
    dayInit = 1;
  } else {
    fechaInicio = fechaInicio.split("-");
    dayInit = fechaInicio[0];
  }

  if (!fechaTermino) {
    dayTerm = getDaysInMonth(
      MESES.indexOf(step1.mesRemuneracion) + 1,
      +step1.anoRemuneracion
    );
  } else {
    fechaTermino = fechaTermino.split("-");
    dayTerm = fechaTermino[0];
  }

  const workedDays = +dayTerm - +dayInit + 1;
  return workedDays < 0 ? `0` : `${workedDays}`;
};

export const repeatedValueString = (repeatedTimes, value) => {
  return Array.apply(null, Array(repeatedTimes))
    .map(() => value)
    .join("");
};

export const addCharacters = (str, chars, times, prepend = true) => {
  const extra = repeatedValueString(times, chars);
  return prepend ? `${extra}${str}` : `${str}${extra}`;
};

export const genTextFileName = () => {
  const today = new Date();

  let name = `PL`;
  name += `${addZeroToNum(today.getMonth())}`;
  name += `DNP_`;
  name += today.getFullYear();
  name += addZeroToNum(today.getMonth());
  name += today.getDate();
  name += `_`;
  name += addZeroToNum(today.getHours());
  name += addZeroToNum(today.getMinutes());
  name += `Z.txt`;

  return name;
};

export const genGroup1Text = (steps) => {
  const { step1 } = steps;
  //const txt = [];
  let objGroup1 = {};

  // * Tipo de registro
  //txt.push(`1`);

  // * Número de folio
  let folio = repeatedValueString(16 - (step1.folio && step1.folio.length ? step1.folio.length : 0), "0");
  folio += step1.folio;
  //txt.push(`${folio}`);
  objGroup1.FOLIO = `${folio}`;

  // * Nombre de transferencia electrónica
  let transfer = `DECLARACION`;
  transfer += repeatedValueString(50 - transfer.length, " ");
  //txt.push(transfer);
  objGroup1.NOMBRE_TE = transfer;

  // * Tipo de pago
  //txt.push(`1`);
  objGroup1.TIPO_P = `1`;

  // * Declaración forzada
  //txt.push(`1`);
  objGroup1.DECLARACION = `1`;

  // * Fecha de la operación
  const today = new Date();
  //txt.push(`${today.getFullYear()}${addZeroToNum(today.getMonth()+1)}${addZeroToNum(today.getDate())}`);
  objGroup1.FECHA_OPERACION = `${today.getFullYear()}${addZeroToNum(today.getMonth()+1)}${addZeroToNum(today.getDate())}`;

  // * Hora de la operación
  //txt.push(`${addZeroToNum(today.getHours())}${addZeroToNum(today.getMinutes())}${addZeroToNum(today.getSeconds())}`);
  objGroup1.HORA_OPERACION = `${addZeroToNum(today.getHours())}${addZeroToNum(today.getMinutes())}${addZeroToNum(today.getSeconds())}`;

  // * Código de identificación manual
  let idenfication = `0001`;
  //txt.push(idenfication);
  objGroup1.IDENTIFICACION = idenfication

  // * Tipo de pagador
  //txt.push(`1`);
  objGroup1.TIPO_PAGADOR = `1`;

  // * Tipo de planilla
  //txt.push(`1`);
  objGroup1.TIPO_PLANILLA = `1`;

  // * New line
  //txt.push("\n");

  //return txt;
  return objGroup1;
};

export const genGroup2Text = (steps) => {
  const { step1, step2 } = steps;
  const today = new Date();
  //const txt = [];
  let objGroup2 = {};

  // * Tipo de registro
  //txt.push(`2`);

  // * Fecha de Pago
  const payYear = today.getFullYear();
  const payMonth = addZeroToNum(today.getMonth() + 1);
  const payDay = addZeroToNum(today.getDate());
  //txt.push(`${payYear}${payMonth}${payDay}`);
  objGroup2.FECHA_PAGO = `${payYear}${payMonth}${payDay}`;

  // * Uso Interno 1
  //txt.push(repeatedValueString(12, "0"));
  objGroup2.USO_INTERNO1 = repeatedValueString(12, "0");
  // * Uso Interno 2
  //txt.push(repeatedValueString(12, "0"));
  objGroup2.USO_INTERNO2 = repeatedValueString(12, "0");

  // * Uso Interno 3
  //txt.push(repeatedValueString(12, "0"));
  objGroup2.USO_INTERNO3 = repeatedValueString(12, "0");

  // * Número Adherente
  //txt.push(repeatedValueString(10, "0"));
  objGroup2.NUMERO_ADHERENTE = repeatedValueString(10, "0");

  // *******************************************************************************************
  // **PASO 1*****
  // *******************************************************************************************

  //#region
  // * Rut del pagador
  // * Digito Verificador Pagador
  const rutRazonSocial = parseRutForTxt(step1.rutRazonSocial);
  //txt.push(addCharacters(rutRazonSocial, "0", 10 - (rutRazonSocial && rutRazonSocial.length ? rutRazonSocial.length : 0)));
  objGroup2.RUT_PAG = addCharacters(rutRazonSocial, "0", 10 - (rutRazonSocial && rutRazonSocial.length ? rutRazonSocial.length : 0));

  // * Razón Social
  let razonSocial = step1.nombreRazonSocial;
  razonSocial += repeatedValueString(50 - (razonSocial && razonSocial.length ? razonSocial.length : 0), " ");
  //txt.push(razonSocial.normalize("NFD").replace(/[\u0300-\u036f]/g, ""));
  objGroup2.NOMBRE_PAG = razonSocial.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

  // * Dirección calle del pagador
  let calle = step1.calle;
  calle += repeatedValueString(50 - (calle && calle.length ? calle.length : 0), " ");
  //txt.push(calle.normalize("NFD").replace(/[\u0300-\u036f]/g, ""));
  objGroup2.DIRECCION_PAG = calle.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

  // * Dirección número del pagador
  let numeroDeCalle = `${step1.numeroDeCalle}`;
  numeroDeCalle += repeatedValueString(10 - (numeroDeCalle && numeroDeCalle.length ? numeroDeCalle.length : 0), " ");
  //txt.push(numeroDeCalle);
  objGroup2.NUMERO_DIRECCION_PAG = numeroDeCalle;

  // * Dirección departamento o Población del pagador
  //txt.push(repeatedValueString(20, " "));
  objGroup2.DEPTO_POBLACION_PAG = repeatedValueString(20, " ");

  // * Dirección comuna del pagador
  let comuna = step1.comuna;
  comuna += repeatedValueString(30 - (comuna && comuna.length ? comuna.length : 0), " ");
  //txt.push(comuna.normalize("NFD").replace(/[\u0300-\u036f]/g, ""));
  objGroup2.COMUNA_PAG = comuna.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

  // * Dirección Ciudad del pagador
  let ciudad = step1.ciudad;
  ciudad += repeatedValueString(30 - (ciudad && ciudad.length ? ciudad.length : 0), " ");
  //txt.push(ciudad.normalize("NFD").replace(/[\u0300-\u036f]/g, ""));
  objGroup2.CIUDAD_PAG = ciudad.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

  // * Dirección Región del pagador
  //txt.push(`${step1.region}`.replace(/0/g, " "));
  objGroup2.REGION_PAG = `${step1.region}`.replace(/0/g, " ");

  // * Teléfono del pagador
  let telefono = step1.telefono;
  telefono += repeatedValueString(20 - (telefono && telefono.length ? telefono.length : 0), " ");
  //txt.push(telefono);
  objGroup2.TELEFONO_PAG = telefono;

  // * FAX del pagador
  //txt.push(repeatedValueString(20, " "));
  objGroup2.FAX_PAG = repeatedValueString(20, " ");

  // * Tasa Cotización Accidentes
  let tasa = `${step1.tasa}`.replace(/\.|,/g, "");
  if (tasa[0] === "0") {
    tasa.slice(1)
  }
  tasa = `${repeatedValueString(5 - (tasa && tasa.length ? tasa.length : 0), "0")}${tasa}`;
  //txt.push(tasa);
  objGroup2.TASA_COTIZACION = tasa;

  // * Tipo Comprobante
  //txt.push("C");
  objGroup2.TIPO_COMPROBANTE = "C";

  // * Tipo Remuneración
  let tipoRemuneracion = step1.tipoRemuneracion === "Remuneración" ? "R" : "G";
  //txt.push(tipoRemuneracion);
  objGroup2.TIPO_REMUNERACION = tipoRemuneracion;

  // * Periodos Pago
  const periodMonth = `${addZeroToNum(
    MESES.indexOf(step1.mesRemuneracion) + 1
  )}`;
  //txt.push(`${step1.anoRemuneracion}${periodMonth}00`);
  objGroup2.PERIODO_PAGO = `${step1.anoRemuneracion}${periodMonth}00`;

  // * Uso Interno 4
  //txt.push(`${repeatedValueString(11, "0")}/00/0000 00:00:00`);
  objGroup2.USO_INTERNO4 = `${repeatedValueString(11, "0")}/00/0000 00:00:00`;
  //#endregion

  // *******************************************************************************************
  // **PASO 2*****
  // *******************************************************************************************

  //#region
  // * Número de Trabajadores Informados
  let numTrabajadores = (step2 && step2.workers && step2.workers.length ? step2.workers.length : 0);
  numTrabajadores = addCharacters(
    numTrabajadores,
    "0",
    7 - `${numTrabajadores}`.length
  );
  //txt.push(numTrabajadores);
  objGroup2.NUMERO_TRABAJADORES = numTrabajadores;

  // * Total Remuneraciones
  let totalRemuneraciones = 0;
  if (step2 && step2.workers && step2.workers.length) {
    step2.workers.forEach((worker) => {
      totalRemuneraciones += +worker["remuneracion imponible"];
    });
    let totalRemuneracionesRedondeado = `${parseInt(totalRemuneraciones)}`
    totalRemuneraciones = addCharacters(
      totalRemuneracionesRedondeado,
      "0",
      12 - totalRemuneracionesRedondeado.length
    );
    //txt.push(totalRemuneraciones);
    objGroup2.TOTAL_REMUNERACIONES = totalRemuneraciones;
  }

  // * Total Cotizaciones
  let cotizacionAPagar = `${parseInt(step2.cotizacionAPagar)}`
  //txt.push(
  //  addCharacters(
  //    cotizacionAPagar,
  //    "0",
  //    12 - cotizacionAPagar.length
  //  )
  //);
  objGroup2.TOTAL_COTIZACIONES =  addCharacters(
        cotizacionAPagar,
        "0",
        12 - cotizacionAPagar.length
      );

  // * Interés Penal
  const interesesPenales = step2.interesesPenales || "";
  //txt.push(addCharacters(interesesPenales, "0", 12 - interesesPenales.length));
  objGroup2.INTERES_PENAL = addCharacters(interesesPenales, "0", 12 - interesesPenales.length);

  // * Reajuste
  const reajustes = step2.reajustes || "";
  //txt.push(addCharacters(reajustes, "0", 12 - reajustes.length));
  objGroup2.REAJUSTES = addCharacters(reajustes, "0", 12 - reajustes.length);

  // * Multas
  const multas = step2.multas || "";
  //txt.push(addCharacters(multas, "0", 12 - multas.length));
  objGroup2.MULTAS = addCharacters(multas, "0", 12 - multas.length);

  // * Diferencias
  const diferenciaDeCotizacion = step2.diferenciaDeCotizacion || "";
  //txt.push(
  //  addCharacters(
  //     diferenciaDeCotizacion,
  //    "0",
  //    12 - diferenciaDeCotizacion.length
  //  )
  //);
  objGroup2.DIFERENCIAS = addCharacters(
    diferenciaDeCotizacion,
    "0",
    12 - diferenciaDeCotizacion.length
  );

  // * Total Gravámenes
  const totalGravamenes =
    +step2.reajustes + +step2.interesesPenales + +step2.multas;
  //txt.push(
  //  addCharacters(totalGravamenes, "0", 12 - `${totalGravamenes}`.length)
  //);
  objGroup2.TOTAL_GRAVAMENES = addCharacters(totalGravamenes, "0", 12 - `${totalGravamenes}`.length);

  // * Total Pagar
  let totalAPagar = `${parseInt(step2.totalAPagar)}`;
  //txt.push(
  //  addCharacters(totalAPagar, "0", 12 - totalAPagar.length)
  //);
  objGroup2.TOTAL_PAGAR = addCharacters(totalAPagar, "0", 12 - totalAPagar.length);

  // * Tipo de Pago
  //txt.push(`1`);
  objGroup2.TIPO_PAGO = `1`;

  // * Fecha de Pago
  //txt.push(repeatedValueString(8, "0"));
  objGroup2.FECHA_PAGO_2 = repeatedValueString(8, "0");

  // * Número de Cheque
  //txt.push(repeatedValueString(12, "0"));
  objGroup2.NUMERO_CHEQUE = repeatedValueString(12, "0");

  // * Plaza Cheque
  //txt.push(repeatedValueString(20, " "));
  objGroup2.PLAZA_CHEQUE = repeatedValueString(20, " ");

  // * Banco Cheque
  //txt.push(repeatedValueString(20, " "));
  objGroup2.BANCO_CHEQUE = repeatedValueString(20, " ");

  // * Uso Interno 5
  //txt.push(repeatedValueString(12, "0"));
  objGroup2.USO_INTERNO5 = repeatedValueString(12, "0");

  // * Uso Interno 6
  //txt.push(repeatedValueString(12, "0"));
  objGroup2.USO_INTERNO6 = repeatedValueString(12, "0");

  // * Uso Interno 7
  //txt.push(repeatedValueString(12, "0"));
  objGroup2.USO_INTERNO7 = repeatedValueString(12, "0");

  // * Uso Interno 8
  //txt.push(repeatedValueString(12, "0"));
  objGroup2.USO_INTERNO8 = repeatedValueString(12, "0");

  // * Uso Interno 9
  //txt.push(repeatedValueString(12, "0"));
  objGroup2.USO_INTERNO9 = repeatedValueString(12, "0");

  // * Nombre representante legal
  //txt.push(
  //  addCharacters(step1.nombreRL, " ", 30 - (step1 && step1.nombreRL && step1.nombreRL.length ? step1.nombreRL.length : 0), false)
  //);
  objGroup2.NOMBRE_REPRESENTANTE_LEGAL = addCharacters(step1.nombreRL, " ", 30 - (step1 && step1.nombreRL && step1.nombreRL.length ? step1.nombreRL.length : 0), false);

  // * Ap. Paterno Rep. Legal
  //txt.push(
  //  addCharacters(
  //    step1.apellidoPaternoRL,
  //    " ",
  //    30 - (step1 && step1.apellidoPaternoRL && step1.apellidoPaternoRL.length ? step1.apellidoPaternoRL.length : 0),
  //    false
  //  )
  //);
  objGroup2.APATERNO_REPRESENTANTE_LEGAL = addCharacters(
    step1.apellidoPaternoRL,
    " ",
    30 - (step1 && step1.apellidoPaternoRL && step1.apellidoPaternoRL.length ? step1.apellidoPaternoRL.length : 0),
    false
  );

  // * Ap. Materno Rep. Legal
  //txt.push(
  //  addCharacters(
  //    step1.apellidoMaternoRL,
  //    " ",
  //    30 - (step1 && step1.apellidoMaternoRL && step1.apellidoMaternoRL.length ? step1.apellidoMaternoRL.length : 0),
  //    false
  //  )
  //);
  objGroup2.AMATERNO_REPRESENTANTE_LEGAL = addCharacters(
    step1.apellidoMaternoRL,
    " ",
    30 - (step1 && step1.apellidoMaternoRL && step1.apellidoMaternoRL.length ? step1.apellidoMaternoRL.length : 0),
    false
  );

  // * Rut del representante legal
  // * Digito Verificador Representante Legal
  const rutRl = parseRutForTxt(step1.rutRL);
  //txt.push(addCharacters(rutRl, "0", 10 - rutRl.length));
  objGroup2.RUT_REPRESENTANTE_LEGAL = addCharacters(rutRl, "0", 10 - rutRl.length);
  // * E-Mail Rep. Legal
  //txt.push(
  //  addCharacters(
  //    step1.correoElectronicoRL || "",
  //    " ",
  //    50 - (step1.correoElectronicoRL || "").length,
  //    false
  //  )
  //);
  objGroup2.EMAIL_REPRESENTANTE_LEGAL = addCharacters(
    step1.correoElectronicoRL || "",
    " ",
    50 - (step1.correoElectronicoRL || "").length,
    false
  );

  // * Uso Interno 10
  //txt.push(repeatedValueString(12, "0"));
  objGroup2.USO_INTERNO10 = repeatedValueString(12, "0");
  // * Uso Interno 11
  //txt.push(repeatedValueString(12, "0"));
  objGroup2.USO_INTERNO11 = repeatedValueString(12, "0");

  // * Uso Interno 12
  //txt.push(repeatedValueString(12, "0"));
  objGroup2.USO_INTERNO12 = repeatedValueString(12, "0");

  // * Uso Interno 13
  //txt.push(repeatedValueString(12, "0"));
  objGroup2.USO_INTERNO13 = repeatedValueString(12, "0");

  // * Tipo Recepción
  //txt.push("P");
  objGroup2.TIPO_RECEPCION = "P";

  // * Total Gratificaciones
  const totalGrat =
    (step1.tipoRemuneracion === "Gratificación" ? step2.totalAPagar : "0");
  //txt.push(addCharacters(totalGrat, "0", 12 - `${totalGrat}`.length));
  objGroup2.TOTAL_GRATIFICACIONES = addCharacters(totalGrat, "0", 12 - `${totalGrat}`.length);

  // * Periodos Desde
  //txt.push(repeatedValueString(6, "0"));
  objGroup2.PERIODO_DESDE = repeatedValueString(6, "0");

  // * Periodos Hasta
  //txt.push(repeatedValueString(6, "0"));
  objGroup2.PERIODO_HASTA = repeatedValueString(6, "0");

  // * New line
  //txt.push("\n");

  //return txt;
  return objGroup2;
};

export const genGroup3Text = (steps) => {
  const { step1, step2 } = steps;
  const today = new Date();
  //const txt = [];
  let objGroup3 = {};
  objGroup3.TRABAJADORES = [];

  if (step2 && step2.workers && step2.workers.length) {
    step2.workers.forEach((worker) => {
      let {
        rut,
        nombre,
        sexo,
        ["apellido materno"]: apellidoM,
        ["apellido paterno"]: apellidoP,
        ["movimiento personal"]: mp,
        ["remuneracion imponible"]: ri,
        ["fecha inicio movimiento"]: fechaInicio,
        ["fecha termino movimiento"]: fechaTermino,
      } = worker;
      let trabajador = {};
      // * Tipo de registro
      //txt.push(`3`);

      // * Rut del trabajador
      // * Digito Verificador del Trabajador
      rut = parseRutForTxt(rut);
      //txt.push(addCharacters(rut, "0", 10 - rut.length));
      trabajador.RUT = addCharacters(rut, "0", 10 - rut.length);

      // * Apellido paterno trabajador
      //txt.push(addCharacters(apellidoP, " ", 30 - apellidoP.length, false));
      trabajador.APELLIDO_PATERNO = addCharacters(apellidoP, " ", 30 - apellidoP.length, false);

      // * Apellido materno del Trabajador
      //txt.push(addCharacters(apellidoM, " ", 30 - apellidoM.length, false));
      trabajador.APELLIDO_MATERNO = addCharacters(apellidoM, " ", 30 - apellidoM.length, false);

      // * Nombres del trabajador
      //txt.push(addCharacters(nombre, " ", 30 - nombre.length, false));
      trabajador.NOMBRES = addCharacters(nombre, " ", 30 - nombre.length, false);

      // * Fecha Nacimiento
      //txt.push(repeatedValueString(8, "0"));
      trabajador.FECHA_NACIMIENTO = repeatedValueString(8, "0");

      // * Sexo
      //txt.push(addCharacters(sexo, " ", 12 - sexo.length, false));
      trabajador.SEXO = addCharacters(sexo, " ", 12 - sexo.length, false);

      // * Días Trabajados
      const workedDays = calcWorkedDays(steps, fechaInicio, fechaTermino);
      //txt.push(addCharacters(workedDays, "0", 12 - workedDays.length));
      trabajador.DIAS_TRABAJADOS = addCharacters(workedDays, "0", 12 - workedDays.length);

      // * Renta Imponible del trabajador
      let riRedondeado = `${parseInt(ri)}`
      //txt.push(addCharacters(riRedondeado, "0", 12 - riRedondeado.length));
      trabajador.REMUNERACION_IMPONIBLE = addCharacters(riRedondeado, "0", 12 - riRedondeado.length);

      // * Uso Interno 14
      //txt.push(repeatedValueString(12, "0"));
      trabajador.USO_INTERNO14 = repeatedValueString(12, "0");

      // * Periodo Pago
      const periodMonth = `${addZeroToNum(
        MESES.indexOf(step1.mesRemuneracion) + 1
      )}`;
      //txt.push(`${step1.anoRemuneracion}${periodMonth}`);
      trabajador.PERIODO_PAGO = `${step1.anoRemuneracion}${periodMonth}`;

      // * Código Mov. Personal
      //txt.push(addCharacters(mp, "0", 2 - mp.length));
      trabajador.MOVIMIENTO_PERSONAL = addCharacters(mp, "0", 2 - mp.length);

      // * Fecha de Inicio Mov. Personal
      //txt.push(
      //  (fechaInicio ? parseDateForTxt(fechaInicio) : repeatedValueString(8, "0"))
      //);
      trabajador.FECHA_INICIO_MOVIMIENTO = (fechaInicio ? parseDateForTxt(fechaInicio) : repeatedValueString(8, "0"));

      // * Fecha de Término Mov. Personal
      //txt.push(
      //  (fechaTermino ? parseDateForTxt(fechaTermino) : repeatedValueString(8, "0"))
      //);
      trabajador.FECHA_TERMINO_MOVIMIENTO = (fechaTermino ? parseDateForTxt(fechaTermino) : repeatedValueString(8, "0"));

      // * Tipo de Línea
      //txt.push("0");
      trabajador.TIPO_LINEA = "0";

      // * Nacionalidad
      //txt.push("0");
      trabajador.NACIONALIDAD = "0";

      // * Cotización Accidente del trabajo
      //txt.push(repeatedValueString(12, "0"));
      trabajador.COTIZACION = repeatedValueString(12, "0");

      // * Sistema de Salud
      //txt.push("0");
      trabajador.SISTEMA_SALUD = "0";

      // * Sistema Previsional
      //txt.push("1");
      trabajador.SISTEMA_PREVISIONAL = "1";

      // * Campo adicional 5
      //txt.push(repeatedValueString(590, " "));
      trabajador.CAMPO_ADICIONAL_5 = repeatedValueString(590, " ");

      // * New line
      //txt.push("\n");
      objGroup3.TRABAJADORES.push(trabajador);
    });
  }

 // return txt;
 return objGroup3;
};

export const genGroup4Text = (steps) => {
  const { step1, step2 } = steps;
  //const txt = [];
  let objGroup4 = {}

  // * Tipo de registro
  //txt.push(`4`);

  // * Periodos Pago
  const periodMonth = `${addZeroToNum(
    MESES.indexOf(step1.mesRemuneracion) + 1
  )}`;
  //txt.push(`${step1.anoRemuneracion}${periodMonth}`);
  objGroup4.PERIODO_PAGO = `${step1.anoRemuneracion}${periodMonth}`;

  // * Sucursal
  //txt.push(repeatedValueString(6, "0"));
  objGroup4.SUCURSAL = repeatedValueString(6, "0");

  // * Dirección Sucursal
  const dir = `${step1.calle} ${step1.numeroDeCalle}`;
  //txt.push(addCharacters(dir, " ", 30 - dir.length, false));
  objGroup4.DIRECCION_SUCURSAL = addCharacters(dir, " ", 30 - dir.length, false);

  // * Comuna Sucursal
  //txt.push(addCharacters(step1.comuna, " ", 29 - (step1 && step1.comuna && step1.comuna.length ? step1.comuna.length : 0), false));
  objGroup4.COMUNA_SUCURSAL = addCharacters(step1.comuna, " ", 29 - (step1 && step1.comuna && step1.comuna.length ? step1.comuna.length : 0), false);

  // * Región Sucursal
  //txt.push(`${step1.region}`.replace(/0/g, " "));
  objGroup4.REGION_SUCURSAL = `${step1.region}`.replace(/0/g, " ");

  // * Número de Trabajadores Informados
  let numTrabajadores = (step2 && step2.workers && step2.workers.length ? step2.workers.length : 0);
  numTrabajadores = addCharacters(
    numTrabajadores,
    "0",
    6 - `${numTrabajadores}`.length
  );
  //txt.push(numTrabajadores);
  objGroup4.NUMERO_TRABAJADORES_INFORMADOS = numTrabajadores;

  // * Nueva Sucursal
  //txt.push(`N`);
  objGroup4.NUEVA_SUCURSAL = `N`;

  // * Tipo Remuneración
  let tipoRemuneracion = (step1.tipoRemuneracion === "Remuneración" ? "R" : "G");
  //txt.push(tipoRemuneracion);
  objGroup4.TIPO_REMUNERACION = tipoRemuneracion;

  // * Total Remuneraciones
  let totalRemuneraciones = 0;
  if (step2 && step2.workers && step2.workers.length) {
    step2.workers.forEach((worker) => {
      totalRemuneraciones += +worker["remuneracion imponible"];
    });
    totalRemuneraciones = addCharacters(
      totalRemuneraciones,
      "0",
      12 - `${totalRemuneraciones}`.length
    );
    //txt.push(totalRemuneraciones);
    objGroup4.TOTAL_REMUNERACIONES = totalRemuneraciones;
  }

  // * Total Gratificaciones
  const totalGrat =
    (step1.tipoRemuneracion === "Gratificación" ? step2.totalAPagar : "0");
  //txt.push(addCharacters(totalGrat, "0", 12 - `${totalGrat}`.length));
  objGroup4.TOTAL_GRATIFICACIONES = addCharacters(totalGrat, "0", 12 - `${totalGrat}`.length);

  // * Período desde
  //txt.push(repeatedValueString(6, "0"));
  objGroup4.PERIODO_DESDE = repeatedValueString(6, "0");

  // * Período hasta
  //txt.push(repeatedValueString(6, "0"));
  objGroup4.PERIODO_HASTA = repeatedValueString(6, "0");

  // * Filler
  //txt.push(repeatedValueString(668, " "));
  objGroup4.FILLER = repeatedValueString(668, " ");

  // * New line
  //txt.push("\n");

  //return txt;
  return objGroup4;
};
